import Personal from "../components/FeatureCardSection/sections/FeaturePersonalReminders";
import Footer from "../components/Footer/Footer";
export default function PersonalRemainder() {
  return (
    <>
      <Personal />
      <Footer />
    </>
  );
}